// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2020-05-19T18:01:38Z                      #

// ##############################################################

import {utils} from "mc/lib";
const {ErrorApi, JsonFetch, Fetch, ParamsFetch} = utils;

import * as UpdateMethods from "./UpdateMethods";

/**
 *  Generated from cz.marbes.poh.controller.ParovaniPlatebController.
 */
export default class ParovaniPlatebApi {
    /**
     * 
     *
     * @param idHlavicka 
     * @param idPripad 
     */
    static zrusitVyrovnaniPripadu(idHlavicka : number, idPripad : number) {
        const uri = serverContextPath + `/api/parovaniPlateb/${idHlavicka}/pripad/${idPripad}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.delete(uri, params));
    }

    /**
     * 
     *
     * @param kodTypPripad 
     * @return 
     */
    static findBankovniUcty(kodTypPripad : string) : Promise<BankovniUcet[]> {
        const uri = serverContextPath + `/api/parovaniPlateb/bankovniUcty`;
        const headers = undefined;
        const params = { kodTypPripad };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, 0, headers));
    }

    /**
     * 
     *
     * @param fulltext 
     * @param typPripadKod 
     * @param maxCount 
     * @return 
     */
    static findPripadFulltext(fulltext : string, typPripadKod : string, maxCount : number) : Promise<Pripad[]> {
        const uri = serverContextPath + `/api/parovaniPlateb/pripad/fulltext`;
        const headers = undefined;
        const params = { fulltext, typPripadKod, maxCount };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Vrátí hlavičky plateb podle předaného filtru.
     *
     * @param filter filtr plateb
     * @param max filtr plateb
     * @return platby
     */
    static findPlatbyByFilter(filter : HlavickaPlatbaFilter, max : number) : Promise<HlavickaPlatbaWrapper[]> {
        const uri = serverContextPath + `/api/parovaniPlateb/filter`;
        const headers = undefined;
        const params = { max };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, UpdateMethods.updateHlavickaPlatbaFilter_642BF1(filter), headers));
    }

    /**
     * 
     *
     * @param pripadId 
     * @param hlavickaPlatbaId 
     * @param castka 
     * @return 
     */
    static vyrovnatPlatbu(pripadId : number, hlavickaPlatbaId : number, castka : BigDecimal) : Promise<VyrovnaniPlatba> {
        const uri = serverContextPath + `/api/parovaniPlateb`;
        const headers = undefined;
        const params = { pripadId, hlavickaPlatbaId, castka };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, 0, headers));
    }

}